import { types } from "../types/types";
const intitalState = {
    allPrograms: [],
};

const programReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.CHANGE_PROGRAMS:
            return {
                ...state,
                allPrograms: action.payload,
            };
        default:
            return { ...state };
    }
};

export default programReducer;
